const api = {
  savePhotosSortOrder(controlNumber) {
    return `/case-photo/${controlNumber}/sort`;
  }
};

export default api;